export default "__VITE_ASSET__CYOUy$eb__"